import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect } from "react";
import { actions, useNotificationStore } from "./store.js";
import Notification_module from "./Notification.module.js";
import "./typography/fonts.css";
const Notification = /*#__PURE__*/ forwardRef(({ id, title, description, color, icon: Icon, duration, isFirstMount }, ref)=>{
    const { isPaused } = useNotificationStore();
    useEffect(()=>{
        if (!isPaused) {
            const startTime = Date.now();
            const timeoutId = setTimeout(()=>{
                actions.dismiss(id);
            }, duration);
            return ()=>{
                const timeElapsed = Date.now() - startTime;
                useNotificationStore.setState((state)=>({
                        ...state,
                        notifications: state.notifications.map((notification)=>notification.id === id ? {
                                ...notification,
                                duration: notification.duration - timeElapsed,
                                isFirstMount: false
                            } : notification)
                    }));
                clearTimeout(timeoutId);
            };
        }
    }, [
        id,
        duration,
        isPaused
    ]);
    return /*#__PURE__*/ jsx("div", {
        className: Notification_module.notificationCard,
        onClick: ()=>actions.dismiss(id),
        role: isFirstMount ? 'alert' : void 0,
        "data-testid": "notification",
        ref: ref,
        children: /*#__PURE__*/ jsxs("div", {
            className: Notification_module.notificationBody,
            children: [
                /*#__PURE__*/ jsxs("div", {
                    className: Notification_module.notificationHeader,
                    children: [
                        Icon && /*#__PURE__*/ jsx("div", {
                            className: Notification_module.notificationIcon,
                            "aria-hidden": "true",
                            "data-testid": "notification-icon",
                            children: /*#__PURE__*/ jsx(Icon, {
                                color: color,
                                testId: Icon.name
                            })
                        }),
                        /*#__PURE__*/ jsx("p", {
                            className: Notification_module.notificationTitle,
                            "data-testid": "notification-title",
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ jsx("div", {
                    className: Notification_module.notificationDescriptionContainer,
                    children: /*#__PURE__*/ jsx("p", {
                        className: Notification_module.notificationDescription,
                        "data-testid": "notification-description",
                        "data-a11y-ignore": "color-contrast",
                        children: description
                    })
                })
            ]
        })
    });
});
Notification.displayName = 'Notification';
export { Notification };
